/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Role } from './role';


/**
 * Permission object
 */
export interface Permission { 
    id?: number;
    permission_type?: string;
    permission_type_definition?: string;
    enabled?: boolean;
    roles?: Array<Role>;
}

